import { render, staticRenderFns } from "./MobileTextPanelToolsHeader.vue?vue&type=template&id=1bd509f7&scoped=true&"
import script from "./MobileTextPanelToolsHeader.vue?vue&type=script&lang=js&"
export * from "./MobileTextPanelToolsHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileTextPanelToolsHeader.vue?vue&type=style&index=0&id=1bd509f7&prod&lang=css&"
import style1 from "./MobileTextPanelToolsHeader.vue?vue&type=style&index=1&id=1bd509f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd509f7",
  null
  
)

export default component.exports